import type { InputHTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-field{display:flex;flex-direction:column;gap:6px;font-family:var(--font-sans)}
.js-field__label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-body)}
.js-field__label .req{color:var(--danger-fg);margin-left:2px}
.js-input-wrap{position:relative;display:flex;align-items:center}
.js-input-wrap__icon{position:absolute;left:12px;display:flex;color:var(--text-subtle);pointer-events:none}
.js-input{
  width:100%;height:var(--control-md);box-sizing:border-box;
  font-family:var(--font-sans);font-size:var(--text-body);color:var(--text-strong);
  background:var(--surface-card);border:1.5px solid var(--border-default);
  border-radius:var(--radius-md);padding:0 14px;
  transition:border-color var(--dur-fast) var(--ease-out),box-shadow var(--dur-fast) var(--ease-out);
}
.js-input::placeholder{color:var(--text-subtle)}
.js-input:hover{border-color:var(--border-strong)}
.js-input:focus{outline:none;border-color:var(--brand);box-shadow:var(--ring-brand)}
.js-input--icon{padding-left:38px}
.js-input--err{border-color:var(--danger-fg)}
.js-input--err:focus{box-shadow:0 0 0 3px var(--danger-bg)}
.js-input[disabled]{background:var(--neutral-100);color:var(--text-subtle);cursor:not-allowed}
.js-field__hint{font-size:var(--text-xs);color:var(--text-subtle)}
.js-field__hint--err{color:var(--danger-fg)}
`;

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  required?: boolean;
  icon?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
}

export function Input({ label, required, icon, hint, error, id, className = "", ...rest }: InputProps) {
  injectCss("js-input-css", CSS);
  const inputCls = [
    "js-input",
    icon ? "js-input--icon" : "",
    error ? "js-input--err" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <label className="js-field" htmlFor={id}>
      {label && (
        <span className="js-field__label">
          {label}
          {required && <span className="req">*</span>}
        </span>
      )}
      <span className="js-input-wrap">
        {icon && <span className="js-input-wrap__icon">{icon}</span>}
        <input id={id} className={inputCls} aria-invalid={!!error} {...rest} />
      </span>
      {(error || hint) && (
        <span className={["js-field__hint", error ? "js-field__hint--err" : ""].join(" ")}>{error || hint}</span>
      )}
    </label>
  );
}
